import crud from "../../../crud";

crud.conf['w-textarea'] = {
    maxlength: 1000,
    charleft: false
}

const wTextareaMixin = {

}
export default wTextareaMixin
